module.exports = __webpack_public_path__ + "img/helpImage.236ae702.svg";